const SKEW_ANGLE_DEG = 12.1;
const TAN_SKEW = Math.tan(SKEW_ANGLE_DEG * Math.PI / 180);

function alignContentBoxGroup(container, cols) {
    // Reset
    cols.forEach(col => col.style.transform = '');
    container.style.paddingLeft = '';

    if (window.innerWidth < 1024) return;
    if (cols.length < 2) return;

    // Group columns by visual row using top position
    const rowMap = new Map();
    cols.forEach(col => {
        const top = Math.round(col.getBoundingClientRect().top);
        if (!rowMap.has(top)) rowMap.set(top, []);
        rowMap.get(top).push(col);
    });

    const sortedRows = [...rowMap.entries()].sort(([a], [b]) => a - b);
    if (sortedRows.length < 2) return;

    const firstRowTop = sortedRows[0][0];
    const lastRowTop  = sortedRows[sortedRows.length - 1][0];
    const maxOffset   = (lastRowTop - firstRowTop) * TAN_SKEW;

    // Pad the container so the first (most-shifted) row stays within bounds
    container.style.paddingLeft = `${maxOffset.toFixed(1)}px`;

    sortedRows.forEach(([rowTop, rowCols]) => {
        const offset = (rowTop - firstRowTop) * TAN_SKEW;
        rowCols.forEach(col => {
            col.style.transform = `translateX(-${offset.toFixed(1)}px)`;
        });
    });
}

export function initContentBoxAlignment() {
    function run() {
        // Group all contentBox cols by the parent of their containing .row.
        // This handles both a single wrapping .row and multiple sibling .row elements.
        const containerMap = new Map();
        document.querySelectorAll('.row > [class*="col-"]').forEach(col => {
            if (!col.querySelector('.contentBox')) return;
            const container = col.parentElement.parentElement;
            if (!container) return;
            if (!containerMap.has(container)) containerMap.set(container, []);
            containerMap.get(container).push(col);
        });

        containerMap.forEach((cols, container) => alignContentBoxGroup(container, cols));
    }

    run();

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(run, 120);
    });
}
